t = require('app/scripts/views/internal/teacup-with-helpers')('badge')

module.exports = ->
  t.span { class: 'badge-icon icon-sm icon-' + t.mustacheVar('icon') }
  t.mustacheBlock 'text', ->
    t.span '.badge-text', ->
      t.text t.mustacheVar('text')
